import { EvidencesTypeValueEnum } from "../../../utils/enums/evidences";
import { DeleteEvidencesUploaded, EvidenceState, Modal, UploadEvidencePayload } from "../types";
import { Types } from "../../../utils/enums";
import { sharedAws } from "../../../service/bucketS3/Storage";
import { EvidenceList } from "../components";
import { filesToType, typeFiles } from "../../../utils/constants/typeFIles";

export const cancelUpload = ({ key, evidenceState }: { key: string; evidenceState: EvidenceState['value'] }) => {
    if (!!key) {
        const splitKey = key.split('-')
        const evidenceType = splitKey[0]
        const keyName = splitKey?.splice(1).join('-')

        if (evidenceState?.[evidenceType]?.value) {
            evidenceState[evidenceType].value = {
                ...(evidenceState?.[evidenceType]?.value ?? {}),
                ...(!!evidenceType &&
                    !!keyName &&
                    !!evidenceState?.[evidenceType]?.value?.[keyName] && {
                    [keyName]: {
                        ...evidenceState[evidenceType].value?.[keyName],
                        progress: true,
                        upload: true,
                        progressAmount: '0',
                    } as any,
                }),
            }
        }
        return {
            items: evidenceState
        }
    }
    return { items: evidenceState }
}

export const deleteEvidenceUploaded = ({ nameFile, t, deletedEvidence, fakeDelete, modal: prev, isDelete, setEvidencesDrawer, handleCloseModal, setSnackbar, setEvidencesRequiredAreLoad, uploadName, isString, value, setIsLoadingConfirm }: DeleteEvidencesUploaded) => {
    const [evidenceType] = nameFile.toString().split('-')
    let title = ''
    switch (evidenceType) {
        case EvidencesTypeValueEnum.IMAGE.toString():
        case EvidencesTypeValueEnum.CAMERA.toString():
            title = t('reportFolio.snackbar.deleteImage')
            break
        case EvidencesTypeValueEnum.COMMENT.toString():
            title = t('reportFolio.snackbar.deleteComment')
            break
        case EvidencesTypeValueEnum.DOCUMENT.toString():
            // case EvidencesTypeValueEnum.FILE.toString():
            title = t('reportFolio.snackbar.deleteDocument')
            break
        case EvidencesTypeValueEnum.SIGN.toString():
            title = t('reportFolio.snackbar.deleteSign')
            break
        case EvidencesTypeValueEnum.VIDEO_GALLERY.toString():
        case EvidencesTypeValueEnum.VIDEO.toString():
            title = t('reportFolio.snackbar.deleteVideo')
            break
        default: title = t('reportFolio.snackbar.areYouSureonDeleteThisFile')
            break
    }
    const modal: Modal = {
        ...prev,
        open: true,
        title,
        description: '',
        children: undefined,
        removeCancel: false,
        method: async () => {
            const splitIndex = nameFile?.toString()?.split('-')
            const keyName = splitIndex?.splice(1).join('-')
            let evidenceCopy = structuredClone(value)
            if (evidenceCopy?.[splitIndex[0]]?.value) {
                delete evidenceCopy[splitIndex[0]].value?.[keyName]
            }
            const valueLength = Object.values(evidenceCopy?.[splitIndex[0]]?.value ?? {})?.length
            const minAmount = evidenceCopy?.[splitIndex[0]]?.minAmount ?? 0
            if (fakeDelete && deletedEvidence) {
                deletedEvidence({ name: `${uploadName}/${keyName}` })
                setEvidencesDrawer((prev) => ({
                    ...prev,
                    value: evidenceCopy,
                }))
                if (minAmount > 0) {
                    setEvidencesRequiredAreLoad((prev) => ({
                        ...prev,
                        [splitIndex[0] ?? '']: !minAmount || (!!minAmount && valueLength > 0),
                    }))
                }
                if (isDelete) { isDelete(true) }
                handleCloseModal()
                return
            }
            setIsLoadingConfirm(true)

            if (!isString) {
                const name = `${uploadName}/${keyName}`
                const response = await sharedAws.delete({ name: name })
                if (!!response) {
                    if (isDelete) { isDelete(true) }
                    setEvidencesDrawer((prev) => ({
                        ...prev,
                        value: evidenceCopy,
                    }))
                    if (minAmount > 0) {
                        setEvidencesRequiredAreLoad((prev) => ({
                            ...prev,
                            [splitIndex[0] ?? '']: !minAmount || (!!minAmount && valueLength > 0),
                        }))
                    }
                    handleCloseModal()
                } else {
                    isDelete?.(false)
                    setIsLoadingConfirm(false)

                    setSnackbar((prev) => ({
                        ...prev,
                        open: true,
                        type: Types.ERROR,
                        message: 'Ocurrió un error al eliminar el archivo',
                    }))
                }
            } else {
                if (minAmount > 0) {
                    setEvidencesRequiredAreLoad((prev) => ({
                        ...prev,
                        [splitIndex[0] ?? '']: !minAmount || (!!minAmount && valueLength > 0),
                    }))
                }

                if (!!splitIndex?.[0] && evidenceCopy?.[splitIndex[0]]) {
                    evidenceCopy = {
                        ...evidenceCopy,
                        [splitIndex?.[0] ?? '']: {
                            ...evidenceCopy[splitIndex[0]],
                            seeFiles: valueLength > 0,
                        },
                    }
                }
                setEvidencesDrawer((prev) => ({
                    ...prev,
                    value: evidenceCopy,
                }))

                handleCloseModal()
            }
        },
    }
    return {
        title,
        modal
    }
}

export const uploadEvidence = async ({
    e,
    name,
    isUpload,
    evidencesDrawer,
    uploadName,
    valueRef,
    fileRef,
    accept,
    isLoad,
    setEvidencesDrawer,
    setEvidencesRequiredAreLoad,
    setOpenModal,
    setSnackbar,
}: UploadEvidencePayload) => {

    const { files } = e.target
    const fileLength = Object.values(files ?? {})?.length
    const evidencesDrawerCoopy = structuredClone(evidencesDrawer)
    const evidencesLength = Object.values(evidencesDrawerCoopy?.value?.[name ?? '']?.value ?? {})?.length
    const minAmount = evidencesDrawerCoopy?.value?.[name ?? '']?.minAmount ?? 0
    const totalFiles = (evidencesLength ?? 0) + fileLength
    const maxCount = evidencesDrawerCoopy?.value?.[name ?? '']?.maxCount ?? 0
    const size = evidencesDrawerCoopy?.value?.[name ?? '']?.size ?? 0
    const isEquealToMaximus = totalFiles == maxCount

    if (fileLength > 0 && (totalFiles <= maxCount || !!isUpload)) {
        let obj_unidos = evidencesDrawerCoopy?.value?.[name as string]?.value ?? {}
        let titleFilesDontUpload = `Los siguientes archivos exceden el tamaño máximo permitido o no corresponden al tipo de evidencia permitido:`
        let titleEvidencesEithTheSameNAme = `Ya existe un archivo con este nombre:`
        let filesDontUpload: string[] = []
        let evidencesEithTheSameNAme: string[] = []

        Object.values(files ?? {})?.forEach((item) => {
            if (accept.includes(filesToType[item.type])) {
                if (!size || item.size < size * 1024000) {
                    const fileName = item?.name.replace(/\s+/g, '');
                    if (!obj_unidos[fileName]) {
                        obj_unidos = {
                            ...obj_unidos,
                            [fileName]: {
                                name: fileName,
                                url: item,
                                progress: true,
                                progressAmount: '0',
                            },
                        }
                    } else {
                        evidencesEithTheSameNAme = [...(evidencesEithTheSameNAme ?? []), fileName ?? '']
                    }
                }
            }
        })

        setEvidencesDrawer((prev) => ({
            ...prev,
            value: {
                ...(prev?.value ?? {}),
                [name ?? '']: {
                    ...(prev?.value?.[name as string] ?? {}),
                    value: obj_unidos,
                    expanded: true,
                },
            },
        }))

        Object.values(files ?? {})?.forEach(async (item) => {
            const fileName = item.name.replace(/\s+/g, '')
            if ((!accept || accept.includes(filesToType[item.type])) && (!size || item.size < size * 1024000)) {
                sharedAws.put({
                    file: item,
                    name: `${uploadName}`,
                    otherBucket: process.env.REACT_APP_EVIDENCES,
                    progressCallback: (load) => {
                        setEvidencesDrawer((prev) => ({
                            ...prev,
                            value: {
                                ...(prev?.value ?? {}),
                                [name ?? '']: {
                                    ...(prev?.value?.[name as string] ?? {}),
                                    value: {
                                        ...prev?.value?.[name as string]?.value,
                                        [fileName]: {
                                            ...(prev?.value?.[name as string]?.value?.[fileName] ?? item),
                                            progressAmount: load.toString(),
                                            url: item,
                                            upload: false,
                                            name: fileName
                                        },
                                    },
                                },
                            },
                        }))
                    },
                    errorCallback: () => {
                        isLoad?.(false)
                        delete valueRef?.current?.[`${name ?? ''}-${fileName ?? ''}`]
                        setEvidencesDrawer((prev) => ({
                            ...prev,
                            value: {
                                ...(prev?.value ?? {}),
                                [name ?? '']: {
                                    ...(prev?.value?.[name as string] ?? {}),
                                    value: {
                                        ...(prev?.value?.[name ?? '']?.value ?? obj_unidos),
                                        [fileName ?? '']: {
                                            ...(prev?.value?.[name ?? '']?.value?.[fileName ?? ''] ?? obj_unidos[fileName]),
                                            progress: true,
                                            upload: true,
                                            progressAmount: undefined,
                                            name: fileName
                                        },
                                    },
                                },
                            },
                        }))
                    },
                    cancelUpload: (ref) => {
                        valueRef.current = {
                            ...valueRef.current ?? {},
                            [`${name ?? ''}-${fileName ?? ''}`]: ref
                        }
                    },
                    completeCallback: (url) => {
                        isLoad?.(true)
                        if (typeof url === 'string' && !!url) {
                            setEvidencesRequiredAreLoad((prev) => ({
                                ...prev,
                                [name ?? '']: !minAmount || (!!minAmount && totalFiles > 0),
                            }))
                            delete valueRef?.current?.[`${name ?? ''}-${fileName ?? ''}`]
                            setEvidencesDrawer((prev) => ({
                                ...prev,
                                value: {
                                    ...(prev?.value ?? {}),
                                    [name ?? '']: {
                                        ...(prev?.value?.[name as string] ?? {}),
                                        value: {
                                            ...(prev?.value?.[name ?? '']?.value ?? obj_unidos),
                                            [fileName ?? '']: {
                                                ...(prev?.value?.[name ?? '']?.value?.[fileName ?? ''] ?? obj_unidos[fileName]),
                                                progressAmount: '100',
                                            },
                                        },
                                    },
                                },
                            }))
                            const setEvidencesDrawerBind = setEvidencesDrawer
                            setTimeout(() => {
                                setEvidencesDrawerBind((prev) => ({
                                    ...prev,
                                    value: {
                                        ...(prev?.value ?? {}),
                                        [name ?? '']: {
                                            ...(prev?.value?.[name as string] ?? {}),
                                            seeFiles: isEquealToMaximus && [EvidencesTypeValueEnum.SIGN.toString()].includes(name ?? ''),
                                            value: {
                                                ...(prev?.value?.[name ?? '']?.value ?? obj_unidos),
                                                [fileName ?? '']: {
                                                    ...(prev?.value?.[name ?? '']?.value?.[fileName ?? ''] ?? obj_unidos[fileName]),
                                                    url: url,
                                                    progress: typeof url !== 'string',
                                                    upload: typeof url !== 'string',
                                                    progressAmount: undefined,
                                                    name: fileName
                                                },
                                            },
                                        },
                                    },
                                }))
                            }, 200)
                        } else {
                            isLoad?.(false)
                            delete valueRef?.current?.[`${name ?? ''}-${fileName ?? ''}`]
                            setEvidencesDrawer((prev) => ({
                                ...prev,
                                value: {
                                    ...(prev?.value ?? {}),
                                    [name ?? '']: {
                                        ...(prev?.value?.[name as string] ?? {}),
                                        value: {
                                            ...(prev?.value?.[name ?? '']?.value ?? obj_unidos),
                                            [fileName ?? '']: {
                                                ...(prev?.value?.[name ?? '']?.value?.[fileName ?? ''] ?? obj_unidos[fileName]),
                                                progress: true,
                                                upload: true,
                                                progressAmount: undefined,
                                                name: fileName
                                            },
                                        },
                                    },
                                },
                            }))
                        }
                    }
                })
            } else {
                filesDontUpload = [...(filesDontUpload ?? []), fileName ?? '']
            }
        })

        if ((!!filesDontUpload?.length || !!evidencesEithTheSameNAme?.length) && !isUpload) {
            setOpenModal((prev) => ({
                ...prev,
                title: '',
                description: undefined,
                children: (
                    <EvidenceList
                        evidencesEithTheSameNAme={evidencesEithTheSameNAme}
                        filesDontUpload={filesDontUpload}
                        titleEvidencesEithTheSameNAme={titleEvidencesEithTheSameNAme}
                        titleFilesDontUpload={titleFilesDontUpload}
                    />
                ),
                open: true,
                removeCancel: true,
                method: () => {
                    setOpenModal((prev) => ({
                        ...prev,
                        open: false,
                        children: undefined,
                        description: undefined
                    }))
                },
            }))
        }
    } else {
        if (!!files && fileLength > 0) {
            setSnackbar((prev) => ({
                ...prev,
                open: true,
                type: Types.ERROR,
                message: 'Se superó el máximo de archivos',
            }))
        }
    }
    if (fileRef?.current) {
        fileRef.current.value = ''
    }
}